<template>
    <div class="mt-95 border-top">
        <v-container>
            <v-row class="align-center justify-md-space-between  justify-center  pb-5 pt-4 ">
                <v-col cols="12" md="7">
                    <div class="text-md-left text-center position-relative about-content ">
                        <h2 class="text-h2 font-weight-bold text-dark mb-4" data-aos="fade-up" data-aos-delay="200"
                            data-aos-duration="1000">Founders</h2>
                        <p class="text-body-1 text-muted bg-surface position-relative z-index1" data-aos="fade-up"
                            data-aos-delay="400" data-aos-duration="1000">
                            Treelet provides founders with the means to confidentially pitch their idea, get it funded and a quick path to test market viability. 
                            <br/>
                            Treelet guarantees swift, qualified and transparent execution at all stages.  Wise resources usage yields more time to calibrate the product for market fitness.  
                            <br/>
                            Viable products are serviced fractionaly by experts implementing proven strategy and tactics for funnel creation and conversion.
                            <br/> 
                            Successful startups graduate from Treelet and continue their growth trajectory. 
                         </p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <div class="pl-sm-6">
                        <v-card elevation="10">
                            <v-card-item class="px-12 py-6">
                                <div class="d-flex align-center  text-sm-left">
                                    <v-avatar size="60" color="lightprimary" class="me-6">
                                        <img src="/images/icon/icon-pricey.svg" alt="icon" width="30" />
                                    </v-avatar>
                                    <div>
                                        <h4 class="font-weight-bold text-dark pr-sm-3 my-sm-0 my-0 text-caption lh-normal">
                                            8</h4>
                                        <p class="text-muted text-subtitle-1">Pitches</p>
                                    </div>
                                </div>
                            </v-card-item>
                            <v-divider></v-divider>
                            <v-card-item class="px-12 py-6">
                                <div class="d-flex align-center  text-sm-left">
                                    <v-avatar size="60" color="lightprimary" class="me-6">
                                        <img src="/images/icon/icon-folks.svg" alt="icon" width="30" />
                                    </v-avatar>
                                    <div>
                                        <h4 class="font-weight-bold text-dark pr-sm-3 my-sm-0 my-0 text-caption lh-normal">
                                            11</h4>
                                        <p class="text-muted text-subtitle-1">Founders</p>
                                    </div>
                                </div>
                            </v-card-item>
                            <v-divider></v-divider>
                            <v-card-item class="px-12 py-6">
                                <div class="d-flex align-center  text-sm-left">
                                    <v-avatar size="60" color="lightprimary" class="me-6">
                                        <img src="/images/icon/icon-request.svg" alt="icon" width="30" />
                                    </v-avatar>
                                    <div>
                                        <h4 class="font-weight-bold text-dark pr-sm-3 my-sm-0 my-0 text-caption lh-normal">
                                            2.5M</h4>
                                        <p class="text-muted text-subtitle-1">Available funding</p>
                                    </div>
                                </div>
                            </v-card-item>
                        </v-card>
                    </div>
                </v-col>
            </v-row>

            
    </v-container>
</div>
</template>

